import React from 'react'
import PropTypes from 'prop-types'
import { TypographyV2 as Typography, themeV2 } from '@taglivros/tag-components'
import Button from '../Button/Button'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import * as S from './style'

const PreventLeavingModal = ( props ) => {
  const {
    show,
    message,
    onCancelActionClick,
    cancelActionButtonLabel,
    onProceedClick,
    proceedButtonLabel,
  } = props

  return (
    <Modal
      altura="auto"
      show={ show }
    >
      <S.ModalContainer>
        <Typography
          as="span"
          color="TAG1-700"
          variant="subtitle-large-bold"
        >
          Atenção
        </Typography>

        <Typography
          as="p"
          color="TAG1-900"
          variant="text-medium-regular"
        >
          { message }
        </Typography>

        <Button
          color={ themeV2.palette[ 'TAG1-700' ] }
          disabled={ false }
          onClick={ onCancelActionClick }
        >
          <Typography
            as="span"
            color="WHITE"
            variant="button-medium-bold"
          >
            { cancelActionButtonLabel }
          </Typography>
        </Button>

        <Button
          border={ `1px solid ${themeV2.palette[ 'TAG1-700' ]}` }
          color={ themeV2.palette.WHITE }
          disabled={ false }
          onClick={ onProceedClick }
        >
          <Typography
            as="span"
            color="TAG1-700"
            variant="button-medium-bold"
          >
            { proceedButtonLabel }
          </Typography>
        </Button>
      </S.ModalContainer>
    </Modal>
  )
}

PreventLeavingModal.propTypes = {
  'cancelActionButtonLabel': PropTypes.string.isRequired,
  'message': PropTypes.string.isRequired,
  'onCancelActionClick': PropTypes.func.isRequired,
  'onProceedClick': PropTypes.func.isRequired,
  'proceedButtonLabel': PropTypes.string.isRequired,
  'show': PropTypes.bool.isRequired,
}

export { PreventLeavingModal }
export default PreventLeavingModal
